import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { WelcomePageResponseSchema } from '@utazzo/shared';
import { toast } from 'sonner';

import type { WelcomePageContent, WelcomePageResponse } from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';
import { extractServerError } from '@/lib/api-error';

const BASE = '/me/welcome-page';
const QK = ['welcome-page'] as const;

export const getWelcomePage = async (): Promise<WelcomePageResponse> => {
  const { data } = await apiClient.get<unknown>(BASE);
  return WelcomePageResponseSchema.parse(data);
};

export const saveWelcomePage = async (
  content: WelcomePageContent,
): Promise<WelcomePageResponse> => {
  const { data } = await apiClient.put<unknown>(BASE, { content });
  return WelcomePageResponseSchema.parse(data);
};

export const useWelcomePage = () =>
  useQuery({ queryKey: QK, queryFn: getWelcomePage, staleTime: 5 * 60_000 });

export const useSaveWelcomePage = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: saveWelcomePage,
    onSuccess: (res) => {
      qc.setQueryData(QK, res);
      toast.success('Welcome page saved');
    },
    onError: (err: unknown) =>
      toast.error(extractServerError(err).message ?? 'Could not save the welcome page'),
  });
};
